import React from 'react';
import PropTypes from 'prop-types';
import { TimerVariant, TradeViewVariant } from '../../types/trade';
import StyledTimer from './Styles';

const propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf([
    TimerVariant.ALERT,
    TimerVariant.BOLD,
    TimerVariant.WARN
  ]),
  location: PropTypes.oneOf([TradeViewVariant.LIST, TradeViewVariant.VDP]),
  isTimerExtended: PropTypes.bool,
  showExtendedIndicator: PropTypes.bool
};

const defaultProps = {
  children: undefined,
  variant: undefined,
  location: undefined,
  isTimerExtended: false,
  showExtendedIndicator: false
};

const Timer = ({
  variant,
  location,
  children,
  isTimerExtended,
  showExtendedIndicator
}) => (
  <StyledTimer
    data-testid="timer"
    variant={variant}
    location={location}
    isTimerExtended={isTimerExtended}
    showExtendedIndicator={showExtendedIndicator}
  >
    {children}
  </StyledTimer>
);

Timer.propTypes = propTypes;
Timer.defaultProps = defaultProps;

export default Timer;
